module.exports = {"metaColumns":[{"title":"序号","dataIndex":"xh","key":"xh","align":"center","scopedSlots":{"customRender":"xh"},"width":70},{"title":"数据ID","dataIndex":"dataId","key":"dataId","sorter":true,"width":200},{"title":"元数据名称","dataIndex":"filename","key":"filename","width":150},{"title":"存储方式","dataIndex":"size","key":"size","width":100},{"title":"数据来源","dataIndex":"createtime","key":"createtime","width":250},{"title":"数据类型","dataIndex":"author","key":"author","width":250},{"title":"操作","dataIndex":"operation","key":"operation","scopedSlots":{"customRender":"action"},"width":250}]}


//////////////////
// WEBPACK FOOTER
// ./static/staticMenu/dataApply.json
// module id = ERPF
// module chunks = 24